/** Shared gallery for the FR and EN pages. No network calls, trackers or dependencies. */
export function initCarnet(root, assets, places) {
  if (!root) return () => {};
  const photo = root.querySelector('#carnet-main-photo');
  const caption = root.querySelector('#carnet-caption');
  const thumbs = root.querySelector('.thumbs');
  if (!photo || !caption || !thumbs) return () => {};
  let place = 'tanlay';
  let index = 0;
  root.querySelectorAll('img[data-photo]').forEach(img => {
    if (assets[img.dataset.photo]) img.src = assets[img.dataset.photo];
  });
  function draw() {
    const list = places[place];
    const current = list[index];
    photo.src = assets[current.id];
    photo.alt = current.alt;
    caption.textContent = `${current.caption} · ${index + 1} / ${list.length}`;
    thumbs.replaceChildren(...list.map((item, i) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.imageIndex = String(i);
      button.setAttribute('aria-label', item.alt);
      button.setAttribute('aria-pressed', String(i === index));
      const img = document.createElement('img');
      img.src = assets[item.id];
      img.alt = '';
      button.appendChild(img);
      return button;
    }));
    root.querySelector('.back').hidden = list.length < 2;
    root.querySelector('.forward').hidden = list.length < 2;
  }
  function choose(id) {
    if (!places[id]) return;
    place = id;
    index = 0;
    root.querySelectorAll('[data-place]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.place === id));
    });
    root.querySelectorAll('[data-reader]').forEach(article => {
      article.hidden = article.dataset.reader !== id;
    });
    draw();
  }
  function onClick(event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const placeButton = target.closest('[data-place], [data-jump]');
    if (placeButton && root.contains(placeButton)) {
      choose(placeButton.dataset.place || placeButton.dataset.jump);
      return; // The anchor still performs its normal scroll.
    }
    const thumb = target.closest('[data-image-index]');
    if (thumb && thumbs.contains(thumb)) {
      index = Number(thumb.dataset.imageIndex);
      draw();
      return;
    }
    if (target.closest('.back')) {
      index = (index - 1 + places[place].length) % places[place].length;
      draw();
    } else if (target.closest('.forward')) {
      index = (index + 1) % places[place].length;
      draw();
    }
  }
  root.addEventListener('click', onClick);
  choose(place);
  return () => root.removeEventListener('click', onClick);
}
